import React, { useState } from "react";
import { useEffect, useRef } from "react";
import styles from "./advisor.module.css";
import Image1 from "../../../../../assests/advisor/moha.png";
import Image2 from "../../../../../assests/advisor/fahinur.png";
import Image3 from "../../../../../assests/advisor/alam.png";

const advisorData = [
  {
    image: Image1,
    name: "Haque Mohammed",
    company: "Business Corners SAS",
    position: "Chairman",
    paragraph:
      "''Our commitment is to provide actionable insights and strategic advice that empower business to unlock new oppurtunities and accelerate growth.''",
  },
  {
    image: Image3,
    name: "Alam Ashraful",
    company: "Business Corners SAS",
    position: "Corporate Director",
    paragraph:
      "''Our mission is to empower businesses by connecting buyers, suppliers, and products, driving sustainable growth in complex markets.''",
  },

  {
    image: Image2,
    name: "Haque Fahinur",
    company: "Business Corners SAS",
    position: "Managing Director",
    paragraph:
      "''We believe well-connected business ecosystems drive global success. At Business Corner, we offer tools, networks, and expertise to achieve it.''",
  },
];
function Advisor() {
  const pRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (pRef.current) {
      observer.observe(pRef.current);
    }

    return () => {
      if (pRef.current) {
        observer.unobserve(pRef.current);
      }
    };
  }, []);

  const [scroll, setScroll] = useState(0);

  // ✅ Correct Previous Button Logic
  const goPrevious = () => {
    setScroll((prevIndex) =>
      prevIndex === 0 ? advisorData.length - 1 : prevIndex - 1
    );
  };

  // ✅ Correct Next Button Logic
  const goNext = () => {
    setScroll((prevIndex) =>
      prevIndex === advisorData.length - 1 ? 0 : prevIndex + 1
    );
  };

  // ✅ Dynamically Select Two Advisors Based on Scroll
  const currentAdvisor = advisorData[scroll];
  const nextAdvisor = advisorData[(scroll + 1) % advisorData.length]; // Loop back for second card

  return (
    <div className={styles.advisor_wrapper}>
      <div className={styles.advisor_container}>
        <div
          ref={pRef}
          className={`${styles.heading} ${isVisible ? styles.show : ""}`}>
          <h2>Our Advisors</h2>
          <p>Guarantee Of The Project Success</p>
        </div>
        <div className={styles.advisorHeading}>
          {/* Left Button */}
          <button className={styles.advisorBTNLeft} onClick={goPrevious}>
            {"<"}
          </button>

          {/* Advisor Cards (Showing 2 Cards Side by Side) */}
          <div className={styles.advisorCard}>
            <div className={styles.advisorInfo}>
              <img
                className={styles.advisorProfil}
                src={currentAdvisor.image}
                alt="advisor"
              />
              <h3>{currentAdvisor.name}</h3>
              {/* <h4>{currentAdvisor.company}</h4> */}
              <h5>{currentAdvisor.position}</h5>
              <p>{currentAdvisor.paragraph}</p>
            </div>
          </div>

          {/* Right Button */}
          <button className={styles.advisorBTNRight} onClick={goNext}>
            {">"}
          </button>
        </div>
      </div>
    </div>
  );
}
export default Advisor;
